import React from 'react';
import { Container } from 'react-bootstrap';

export default function AdminToolsDashboard() {
  return (
    <Container fluid className="p-4">
      <h2>Bienvenido a las herramientas administrativas de TOMi digital</h2>
    </Container>
  );
}

